// extracted by mini-css-extract-plugin
export default {"wrapper":"oaJ7B","content":"toiZR","text":"YRvN6","loader":"jHsQs","rotation":"nMIBU"};